import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBuildingBlock12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconBuildingBlock12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 2h-1a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5M1 3v.085A1.5 1.5 0 0 0 0 4.5v5A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5v-5a1.5 1.5 0 0 0-1-1.415V2.5A1.5 1.5 0 0 0 9.5 1h-1A1.5 1.5 0 0 0 7 2.5V3H5v-.5A1.5 1.5 0 0 0 3.5 1h-1A1.5 1.5 0 0 0 1 2.5zm7 0h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM7 4H1.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBuildingBlock12);
